import React from 'react'
import styled from 'react-emotion'
import { color } from '../../style'
import { connect } from 'react-redux'
import { colWidthSelector } from '../../store/selectors/boardSelectors'
import { selectThread } from '../../store/actions/discuss'
import { activeThreadSelector } from '../../store/selectors/discussSelectors'
import { compose, setStatic, withHandlers } from 'recompose'
import { replace } from 'react-router-redux'

const size = 20
const hoverSize = 30

export const ThreadNumber = styled(
  React.forwardRef(({ number, goToThread, className }, ref) => (
    <span onClick={goToThread} className={className} ref={ref}>
      {number}
    </span>
  ))
)(({ top, left, resolved, active, unread }) => {
  const style = {
    label: 'ThreadNumber',

    height: size,
    minWidth: size,
    padding: '0 4px',
    fontWeight: 600,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: active || unread ? 'white' : color.black,
    background: active
      ? color.black
      : unread
        ? color.red
        : resolved
          ? color.greyLine
          : 'white',

    borderRadius: hoverSize / 2,
    borderStyle: resolved ? 'dashed' : 'solid',
    borderWidth: 1,
    borderColor: active ? 'white' : unread ? color.redLine : color.black,

    cursor: 'pointer'
  }
  if (top !== undefined && left !== undefined) {
    style.position = 'absolute'
    style.top = top
    style.left = left
    style.transform = 'translate(-50%, -50%)'
    style['&:hover'] = {
      transform: style.transform + ' scale(1.5)'
    }
  }
  return style
})

const ThreadNumberContianer = compose(
  connect(
    (state, { thread, inline }) => {
      const props = {
        id: thread.id,
        number: thread.number,
        resolved: !!thread.dateResolved,
        active: activeThreadSelector(state) === thread.id,
        unread: !thread.read
      }
      if (!inline) {
        const colWidth = colWidthSelector(state)
        props.top = thread.top * colWidth
        props.left = thread.left * colWidth
      }
      return props
    },
    {
      selectThread,
      goTo: replace
    }
  ),
  withHandlers({
    goToThread: ({ thread, asLink, selectThread, goTo }) => () => {
      if (asLink) {
        goTo(
          window.location.pathname + '#t' + thread.id,
          thread.blockId
            ? {
                scrollTo: thread.blockId
              }
            : {}
        )
      } else {
        selectThread(thread.id)
      }
    }
  }),
  setStatic('className', ThreadNumber.toString())
)

export default ThreadNumberContianer(ThreadNumber)
